import { render, staticRenderFns } from "./CartToast.vue?vue&type=template&id=ed4349c0&"
import script from "./CartToast.vue?vue&type=script&lang=js&"
export * from "./CartToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports